import { atom } from "jotai";

type NavTheme = "light" | "dark";
export const navThemeAtom = atom<NavTheme>("dark");

// type NavTransitionSection={
//     ref: React.RefObject<HTMLDivElement>
//     navTheme: NavTheme
// }

export const navTransitionSectionsAtom = atom<any>({});
